/**
 * Convenience wrapper around react_track for tracking site impressions
 *
 * @author    Arthur Buldauskas <abuldauskas@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

const TrackSiteImpression = props => {
  props.tracker.track(
    {eventType: props.tracker.eventTypes.impression, ...props.data},
    {clientOnly: true, once: true}
  );

  return props.children;
};

TrackSiteImpression.propTypes = {
  tracker: PropTypes.object.isRequired,
  children: PropTypes.node,
  data: PropTypes.object,
};

TrackSiteImpression.defaultProps = {
  children: <Fragment />,
  data: {},
};

export default TrackSiteImpression;
